module.exports = __webpack_public_path__ + "static/media/interview32.39c284ec.jpeg";